<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Pengingat Pengambilan`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <label class="m-d-0 f-14 f-c-midgrey f-regular">Ingatkan setelah</label>
                    <div class="input-group remove-padding mod">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="4,7,14"
                            id="durations"
                            v-model="duration"
                            autocomplete="off"
                            @input="setDuration"
                        />
                        <div class="input-group-prepend">
                            <span class="input-group-text">Hari tdk diambil</span>
                        </div>
                    </div>
                    <label class="m-d-0 f-12 f-c-midgrey f-regular">
                        Jika ingin dikirim beberapa kali, gunakan tanda koma. Contoh: 1,3,5 maka pengingat akan dikirim
                        3 kali pada hari ke 1, 3 dan 5.
                    </label>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Simpan'"
                        :id="'do-update'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="doUpdate"
                    />
                    <SOButton
                        :outline="true"
                        :full="true"
                        :text="'Batal'"
                        :id="'batal-do-update'"
                        :disable="isFetching"
                        :loading="isFetching"
                        @action="back"
                    />
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";
export default {
    name: "DurationUpdate",
    components: {
        SOSlotModal,
        SOButton,
    },
    data() {
        return {
            modalId: "update-duration",
            duration: null,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();
    },
    computed: {
        ...mapGetters(moduleName, {
            settingOutlet: "settingOutlet",
            response: "response",
            isFetching: "isFetching",
        }),
        getSetting() {
            return this.settingOutlet.setting;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            getSettingWa: `${moduleName}/getSettingWa`,
            changeSettingTemplate: `${moduleName}/changeSettingTemplate`,
        }),
        async back() {
            await this.$router.go(-1);
        },
        init() {
            this.duration = this.getSetting.durasi_ambil;
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setDuration(e) {
            this.duration = e.target.value.replace(/[^0-9,]+/g, "");
        },
        doUpdate() {
            let {
                duration,
                getSetting: { iddevice, idoutlet, wa_ambil },
            } = this;

            let posted = {
                iddevice,
                idpayload: "ambil",
                idoutlet,
                status: wa_ambil,
                durasi: duration,
            };

            this.changeSettingTemplate(posted)
                .then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200 && status) {
                        this.back();
                        this.getSettingWa({ idoutlet });
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
    },
};
</script>
